/**
 * The gold ring round the saddlecloth number and gold confidence dots (a gold ring round
 * the Prime Pick badge on high-probability rows, which have neither) on a Prime Pick whose
 * write-up says it has run to a winning standard (isStandardClaim). It's a staff-only
 * trial, so these words are only seen by staff.
 */
export const STANDOUT_TITLE = 'Has run to a winning standard';

/** Appended to the card's accessible name, so the gold is not the only signal. */
export const STANDOUT_LABEL = ', has run to a winning standard';
